export default class imageInformation {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/directives/image-bank/image-info.html'),
            scope: {}, // Isolated.
            controller: ['$scope', '$element', '$attrs', '$timeout', (scope, element, attributes, $timeout) => {
                var mimeTypeIdToNameMap = {
                    1: 'png',
                    2: 'jpeg',
                    3: 'gif'
                };
                scope.show = false;

                scope.$on('imageBank:image:showInfo', function(event, data) {
                    scope.image = data['image'];
                    scope.show = true;
                    scope.publicPath = data['publicPath'];
                    scope.mimeType = mimeTypeIdToNameMap[scope.image.image_type_id];
                });

                scope.$on('clipboardCopy:callback:copied', function() {
                    scope.copied = true;

                    $timeout(function() {
                        scope.copied = false;
                    }, 1000);
                });

                $(document).keyup(function(e) {
                    if (e.keyCode == 27 && scope.show) {
                        scope.show = false;
                        scope.$apply();
                        scope.$emit('imageBank:image:closed');
                    }
                });

                scope.close = function() {
                    scope.show = false;
                    scope.$emit('imageBank:image:closed');
                }
            }]
        }
    }
}
